/**
 * O X de limpar um campo de escolha.
 *
 * A regra é uma só, e estava escrita em três lugares com três respostas diferentes: o campo
 * de seleção olhava obrigatoriedade, o de relacionamento não, e o de relacionamento com
 * criação não olhava nem obrigatoriedade nem somente-leitura. Resultado: o X aparecia em
 * campo obrigatório, oferecendo esvaziar o que o modelo exige — e o erro só aparecia depois,
 * ao salvar.
 *
 * Quatro condições, todas necessárias:
 *
 * - **um valor só.** No múltiplo não há o que limpar de uma vez: quem tira é o fecho de cada
 *   chip, um a um.
 * - **editável.** Em somente-leitura nada se mexe, e um X ali é um botão que mente.
 * - **pode ficar vazio.** Obrigatório não se limpa.
 * - **a remoção é permitida.** É o caso do campo reverso protegido, onde tirar o vínculo
 *   deixaria o documento do outro lado sem um campo obrigatório DELE, ou mudaria a
 *   identidade dele. Quem sabe disso é o campo reverso, que passa `allowRemove`.
 */
export function isClearable(field: {
    multiple?: boolean
    readonly?: boolean
    required?: boolean
    allowRemove?: boolean
}): boolean {
    return !field.multiple && !field.readonly && !field.required && field.allowRemove !== false
}

/**
 * A setinha de abrir a lista de um campo de escolha: só quando a lista abre.
 *
 * Travado, o campo não abre lista nenhuma, e a seta prometia uma escolha que não há — foi o que
 * apareceu quando a seleção e o relacionamento calculados passaram a usar o campo de escolha, para
 * ter o mesmo desenho dos gravados. `undefined` deixa o ícone padrão do Vuetify; texto vazio o tira.
 */
export function menuIconOf(readonly: boolean): string | undefined {
    return readonly ? '' : undefined
}
